export const MAX_RANDOM_DIGITS_AT_ONE_TIME = 3; //due to bit limit on Math.random
export const generators = {
  randomNumberString: (maxDigits: number): string => {
    if (maxDigits <= MAX_RANDOM_DIGITS_AT_ONE_TIME) {
      const num = (Math.random() * Math.pow(10, maxDigits)) | 0;
      return (num + "").padEnd(maxDigits, "0");
    } else {
      return (
        generators.randomNumberString(MAX_RANDOM_DIGITS_AT_ONE_TIME) +
        generators.randomNumberString(maxDigits - MAX_RANDOM_DIGITS_AT_ONE_TIME)
      );
    }
  },
};
export default generators;
